import React, { useEffect, useState } from "react";
import { useQueryParms } from "../../../hooks/useQueryParams";
import axios from "axios";

export const useGetPlayerInfo = ()=>{
        const { pathname } = useQueryParms();
        const playerId = pathname?.split('/')?.[2]
        const url = 'https://web-production-58ed.up.railway.app/api/jugador/id';
        const [playerInfo, setPlayerInfo] = useState('')
    
        useEffect(()=>{
            if(!playerId) return;
            axios.get(url,{params:{player: playerId}}).then(res =>{
                setPlayerInfo(res.data?.player)
                console.log(res)
            }).catch(e => console.log('e',e))
    
        },[playerId])

        return{ playerInfo}

}